import { render } from "./PrivacyPolicy.vue?vue&type=template&id=41527301"
import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PrivacyPolicy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41527301"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41527301', __exports__)) {
    api.reload('41527301', __exports__)
  }
  
  module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=41527301", () => {
    api.rerender('41527301', render)
  })

}


export default __exports__